var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0.85 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.854a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM4.102 4.955a.56.56 0 0 1 .794 0l1.102 1.102 1.101-1.102a.562.562 0 0 1 .795.795L6.792 6.85l1.102 1.102a.562.562 0 0 1-.795.795L5.998 7.645 4.896 8.747a.562.562 0 0 1-.795-.795l1.102-1.1L4.102 5.75a.56.56 0 0 1 0-.795z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXmark);
export default __webpack_public_path__ + "static/media/circle-xmark.65427846353512a3e91df013be9fe6b7.svg";
export { ForwardRef as ReactComponent };